export default "__VITE_ASSET__DLEv_b$g__"